import { Segmented } from "antd"
import { useLocation, useNavigate, useParams } from "react-router"

import { RoutesPaths } from "../../../constants/user-routes"
import PublicApiPage from "./components/PublicApiPage"
import WebhooksPage from "./components/WebhooksPage"

import "./styles.less"

const pageOptions = [
  { value: "public_api", label: "Public API" },
  { value: "webhooks", label: "Webhooks" }
]

/**
 * Developers screen — Settings → Other → Developers for merchants
 * (`/settings/developers`), Settings → Public API for admins.
 *
 * `tab` and `basePath` come from whoever renders it, so the same component
 * works under both addresses; `hash` is the fallback for older call sites.
 */
const PublicAPI = ({ tab, basePath }) => {
  const { hash } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  // Rendered from Settings it gets an explicit basePath; reached by its own route
  // it navigates within the Settings section that owns it (CHA1-2847).
  const base = basePath ?? RoutesPaths.settings.developers
  const requested = tab ?? hash
  const page = pageOptions.some(({ value }) => value === requested) ? requested : "public_api"

  return (
    <div className="public-api">
      <div className="public-api-segmented">
        <Segmented
          options={pageOptions}
          onChange={(val) => navigate(`${base}/${val}`)}
          value={page}
        />
      </div>
      {page === "public_api" && <PublicApiPage />}
      {page === "webhooks" && <WebhooksPage />}
    </div>
  )
}

export default PublicAPI
